enum LessonType {
  QUIZ = 'quiz',
  MEDIA = 'media',
  TEXT = 'text',
}
export default LessonType;
